import { useContext, useEffect } from 'react';
import MapContext from "../MapContext.js";
export default function DeckGLLayer(props) {
  const {
    layer,
    index,
    append = false
  } = props;
  const {
    addLayers,
    removeLayers
  } = useContext(MapContext);

  // useEffect( () => {

  // }, [ layer, index, addLayers, append, removeLayers ] )

  useEffect(() => {
    addLayers(layer, append ? Number.MAX_SAFE_INTEGER : index);
    return () => {
      removeLayers(layer);
    };
  }, [layer, index, append]);
  return null;
}